import './bml-course-detail.scss';
import { fetchWithAccessCheck } from '../../dynamic-page/page-access';
import { loadContentForNewElements } from '../../content-editor-src';
import { CourseLecturersSelector } from '../../course-lecturers/course-lecturers-selector';
import { CourseDetailTable } from '../../dynamic-table/course-detail-table';
import { isAuthenticated } from '../../auth';
import { initSortable } from '../../block-system/block-manager/block-sortable';

const TEMPLATE = `
<section class="precision-laboratory fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6"></div>
            <div class="col-lg-6 col-md-6">
                <h3 class="header-course-detail"
                    data-content="course-detail-title"
                    data-page="course-detail"
                    data-animate-child data-delay="200"></h3>
                <p data-content="course-detail-description"
                   data-page="course-detail"
                   data-type="rich-text"
                   data-animate-child data-delay="400">
                    BML поєднує інновації та експертизу для надання точних діагностичних рішень...
                </p>
                <button class="course-subscription" id="course-subscription-btn-1">
                    Записатись на курс
                </button>
            </div>
        </div>
        <div class="course-stats-container">
            <div class="stat-box-course precision-results" data-animate-child data-delay="200">
                <p class="stat-number-1" data-content="course-start-label" data-page="course-detail">Початок курсу</p>
                <p class="stat-description-1" data-content="course-start-date" data-page="course-detail">13.06.2025 (тривалість: 1 день)</p>
            </div>
            <div class="stat-box-course precision-results" data-animate-child data-delay="600">
                <p class="stat-number-1" data-content="course-location-label" data-page="course-detail">Місце проведення</p>
                <p class="stat-description-1" data-content="course-location" data-page="course-detail">м. Львів, проспект Шевченка 28</p>
            </div>
            <div class="stat-box-course precision-results" data-animate-child data-delay="800">
                <p class="stat-number-1" data-content="course-price-label" data-page="course-detail">Вартість</p>
                <p class="stat-description-1" data-content="course-price" data-page="course-detail">6000 грн</p>
            </div>
        </div>
        <div class="course-image-container">
            <img class="course-page-image"
                 src=""
                 alt="Course image"
                 data-content="course-detail-main-image"
                 data-type="image"
                 data-page="course-detail">
        </div>
    </div>
</section>

<section class="maps container-fluid fade-up">
    <div class="row">
        <div class="col-lg-6 col-md-6">
            <p class="section-label" data-animate-child>Відповіді та підтримка</p>
        </div>
        <div class="col-lg-6 col-md-6">
            <h3 data-animate-child>Програма</h3>
            <p data-animate-child>Досліджуйте, як BML забезпечує точну діагностику за допомогою інноваційних
                методів, вирішуючи складні медичні випадки з точністю та експертизою. Відкрийте для себе реальні
                рішення, які змінюють ситуацію в догляді за пацієнтами.</p>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6"></div>
        <div class="col-lg-6 col-md-6" id="course-modules-col"></div>
    </div>
</section>

<section class="our-team fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <p class="section-label" data-animate-child>Команда BML</p>
            </div>
            <div class="col-lg-6 col-md-6">
                <h3 class="team-member__name" data-animate-child data-delay="200">Лектори курсу</h3>
                <p class="team-member__description" data-animate-child data-delay="400">
                    Досліджуйте, як BML забезпечує точну діагностику через спрощений процес.
                    Від подачі зразків до консультації з експертом, наш чотирьохетапний підхід
                    гарантує надійні результати з швидкістю та професійною інтерпретацією.
                </p>
            </div>
        </div>
        <section id="course-lecturers-section">
            <div id="course-selected-lecturers" class="container-fluid"></div>
        </section>
    </div>
</section>

<section class="precision-laboratory fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6"></div>
            <div class="col-lg-6">
                <h3 data-animate-child data-delay="200">Картка заходу</h3>
                <p data-animate-child data-delay="400">
                    (майстер-клас, симуляційний тренінг, тренінг з оволодіння практичними навичками, тренінг,
                    семінар, фахова (тематична) школа) БПР МЕДИЧНИХ ТА ФАРМАЦЕВТИЧНИХ ПРАЦІВНИКІВ
                </p>
            </div>
        </div>
        <table class="spec-table"></table>
        <div class="row">
            <div class="col-lg-6"></div>
            <div class="col-lg-6">
                <button class="course-subscription" id="course-subscription-btn">
                    Записатись на курс
                </button>
            </div>
        </div>
    </div>
</section>

<div id="course-registration-modal" class="course-modal">
    <div class="course-modal-content">
        <div class="course-modal-close" id="course-modal-close">
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="30" height="30" rx="15" fill="#EBFBFF"/>
                <rect x="9.25488" y="8.37109" width="17.5" height="1.25" rx="0.625"
                      transform="rotate(45 9.25488 8.37109)" fill="#009DC9"/>
                <rect x="8.37061" y="20.7461" width="17.5" height="1.25" rx="0.625"
                      transform="rotate(-45 8.37061 20.7461)" fill="#009DC9"/>
            </svg>
        </div>
        <div class="contact-circles-container" data-animate-circles>
            <div class="contact-circle contact-circle-large"></div>
            <div class="contact-circle contact-circle-medium"></div>
            <div class="contact-circle contact-circle-small"></div>
        </div>
        <section class="contact-us-course">
            <div class="contact-container">
                <h4>Запис на курс</h4>
                <form class="contact-form">
                    <div class="input-row">
                        <div class="input-wrapper">
                            <input type="text" class="input-field" id="course-name" placeholder="">
                            <label for="course-name" class="floating-label">Ім'я</label>
                        </div>
                        <div class="input-wrapper wrapper-phone">
                            <input type="tel" id="course-phone" class="input-field">
                            <label for="course-phone" class="floating-label">Телефон</label>
                        </div>
                    </div>
                    <div class="input-wrapper" data-animate-child>
                        <input type="email" class="input-field" id="course-email" placeholder="">
                        <label for="course-email" class="floating-label">E-Mail</label>
                    </div>
                    <div class="input-wrapper">
                        <textarea class="input-field text-area" id="course-message" placeholder=""></textarea>
                        <label for="course-message" class="floating-label">Повідомлення</label>
                    </div>
                    <div class="input-wrapper checkbox-wrapper">
                        <label class="checkbox-label">
                            <input type="checkbox" class="checkbox-input">
                            <span class="checkbox-text">Я прочитав, розумію та погоджуюсь з <a href="/privacy-policy" target="_blank">Політикою конфіденційності</a> та <a href="/personal-data-policy" target="_blank">Політикою обробки персональних даних</a></span>
                        </label>
                    </div>
                    <div class="input-wrapper">
                        <button type="submit" class="submit-btn">Відправити заявку</button>
                    </div>
                </form>
            </div>
        </section>
    </div>
</div>
`;

class BmlCourseDetail extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;

        const path = window.location.pathname;
        const pathMatch = path.match(/\/course\/([^/]+)/);
        const slug = pathMatch ? pathMatch[1] : new URLSearchParams(window.location.search).get('slug');
        if (!slug) return;

        // Phase 1 (sync): resolve page title and update data-page attributes
        const pageTitle = `Course - ${slug}`;
        this._applyPageTitle(pageTitle);

        // Phase 2 (async): fetch entity, verify access
        this._loadData(slug, pageTitle);

        this._initModal();
        this._initCourseComponents(slug);
    }

    _applyPageTitle(pageTitle) {
        document.body.setAttribute('data-page', pageTitle);

        // Replace placeholder data-page="course-detail" with the real page title
        this.querySelectorAll('[data-page="course-detail"]').forEach(el => {
            el.setAttribute('data-page', pageTitle);
        });
    }

    async _loadData(slug, pageTitle) {
        const data = await fetchWithAccessCheck(`/api/courses/slug/${slug}`, 'course');

        if (data) {
            document.title = `${data.title} - BML`;

            // Re-apply page title (in case async beat sync)
            this._applyPageTitle(pageTitle);
        }

        loadContentForNewElements([...this.querySelectorAll('[data-content]')]);
    }

    _initModal() {
        const modal = this.querySelector('#course-registration-modal');
        const closeBtn = this.querySelector('#course-modal-close');
        if (!modal) return;

        this.querySelectorAll('.course-subscription').forEach(btn => {
            btn.addEventListener('click', () => {
                modal.classList.add('show');
                document.body.style.overflow = 'hidden';
            });
        });

        const close = () => {
            modal.classList.remove('show');
            document.body.style.overflow = '';
        };

        closeBtn?.addEventListener('click', close);
        modal.addEventListener('click', e => { if (e.target === modal) close(); });
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape' && modal.classList.contains('show')) close();
        });
    }

    _initCourseComponents(slug) {
        if (!window.courseLecturersSelector) {
            window.courseLecturersSelector = new CourseLecturersSelector();
        } else {
            window.courseLecturersSelector.displaySelectedDoctors();
        }

        if (!window.courseDetailTable) {
            window.courseDetailTable = new CourseDetailTable();
        } else {
            window.courseDetailTable.init();
        }

        this._initModulesSection(slug);
    }

    _initModulesSection(slug) {
        const col = this.querySelector('#course-modules-col');
        if (!col) return;

        let modulesList = this.querySelector('#course-modules-section');
        if (!modulesList) {
            modulesList = document.createElement('div');
            modulesList.id = 'course-modules-section';
            modulesList.className = 'course-modules-section';
            modulesList.setAttribute('data-section', 'course-modules-section');
            col.appendChild(modulesList);
        }

        if (isAuthenticated()) {
            try { initSortable(modulesList); } catch { /* sortable not critical */ }

            const controls = document.createElement('div');
            controls.className = 'section-controls';
            controls.innerHTML = `
                <span style="font-weight:500;margin-right:auto">Модулі курсу</span>
                <button class="add-module-btn" style="padding:8px 16px;background:#4285f4;color:#fff;border:none;border-radius:4px;cursor:pointer;font-weight:500">
                    Додати модуль
                </button>
            `;
            controls.querySelector('.add-module-btn').addEventListener('click', () => {
                window.blockSystemAPI?.addBlock?.(modulesList, 'course-module');
            });
            col.insertBefore(controls, modulesList);
        }
    }
}

customElements.define('bml-course-detail', BmlCourseDetail);
